import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';

import UserInfo from './UserInfo';
import Buttons from './Buttons';
import { useGlobal } from 'reactn';
import RouteLink from '../../router/RouteLink';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        menuButton: {
            marginRight: theme.spacing(2),
        },
        logoutButton: {
            marginLeft: theme.spacing(2),
        },
        title: {
            flexGrow: 1,
            color: 'white',
        },
    }),
);

export function AppHeader(props: { handleDrawerOpen: () => void; handleDrawerClose: () => void }) {
    const [globalState] = useGlobal();

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton
                        edge="start"
                        className={classes.menuButton}
                        color="inherit"
                        onClick={props.handleDrawerOpen}
                        aria-label="menu"
                    >
                        <MenuIcon />
                    </IconButton>
                    <RouteLink
                        to="/"
                        onClick={props.handleDrawerClose}
                    >
                        <HomeIcon style={{ color: "white", verticalAlign: "middle", marginRight: "8px" }} />
                    </RouteLink>
                    <RouteLink
                        to="/"
                        onClick={props.handleDrawerClose}
                        style={{ textDecoration: 'none' }}
                        key="Configurations List"
                        className={classes.title}
                    >
                        <Typography variant="h6">Retailer Optin/Optout Configuration</Typography>
                    </RouteLink>
                    <UserInfo keycloakState={globalState.keycloakState} />
                    <div className={classes.logoutButton}>
                        <Buttons keycloakState={globalState.keycloakState} />
                    </div>
                </Toolbar>
            </AppBar>
        </div>
    );
}
